import { useQuery } from 'react-query'
import request from '../request'

export const useGetVinSolutionsDealerships = () => {
  return useQuery<Array<{ DealerId: number; Name: string; City: string; State: string }>>(
    ['admin', 'vinsolutions', 'dealerships'],
    ({ signal }) =>
      request({
        url: `/admin/vinsolutions/dealerships`,
        method: 'GET',
        signal,
      }).then((res: any) => res.data),
  )
}
